import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import {
  IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions,
} from '../../../income-tax/personal/personal/income-tax-personal-child-federal-in-income-tax-personal.options';

@translationBaseKey('income-tax-personal-child-federal-in-salary-dividend-options')
export class IncomeTaxPersonalChildFederalInSalaryDividendOptions implements IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions {

  @clonePropertyMetadata<IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions>(IncomeTaxPersonalChildFederalInIncomeTaxPersonalOptions, 'careExpensesOthers')
  careExpensesOthers: number;
}
